import { UpdateAcknowledgementStateAction } from './acknowledgementActions';
import {
  UpdateDepositFileNameAction,
  UpdateDepositFileKeysAction,
  UpdateTransactionStatusAction,
  UpdateDepositStatusAction,
  UpdateBeaconChainAPIStatusAction,
} from './depositFileActions';
import { UpdateWorkflowAction } from './workflowActions';
import { UpdateClientAction } from './clientActions';
import {
  UpdateTargetValidatorAction,
  UpdateSourceValidatorAction,
  UpdateConsolidationStatusAction,
  UpdateValidatorsAction,
} from './consolidationActions';

export enum ActionTypes {
  updateAcknowledgementState,
  updateDepositFileKeys,
  updateDepositFileName,
  updateTransactionStatus,
  updateDepositStatus,
  updateWorkflow,
  updateClient,
  updateBeaconChainAPIStatus,
  updateValidators,
  updateSourceValidator,
  updateTargetValidator,
  updateConsolidationStatus,
}

export type Action =
  | UpdateAcknowledgementStateAction
  | UpdateDepositFileKeysAction
  | UpdateTransactionStatusAction
  | UpdateTransactionStatusAction
  | UpdateDepositStatusAction
  | UpdateWorkflowAction
  | UpdateDepositFileNameAction
  | UpdateClientAction
  | UpdateBeaconChainAPIStatusAction
  | UpdateValidatorsAction
  | UpdateSourceValidatorAction
  | UpdateTargetValidatorAction
  | UpdateConsolidationStatusAction;
